import React, { useState } from 'react';
import {
  Calendar, ChevronFirst, ChevronLast, ChevronLeft, ChevronRight,
  Printer, Save, FileText, Grid3x3, Share
} from 'lucide-react';
import styles from './EcobankCheque.module.css';

export default function EcobankCheque() {
  const [formData, setFormData] = useState({
    paymentType: 'CHEQUE',
    bankCode: 'ECOBANK',
    chequeNumber: '21',
    chequeSecurityNo: '023333/3/21',
    voucher: '16701',
    payee: '',
    batchNumber: '250902/ECOBANK',
    date: '02/09/2025',
    amount: '3,369,210.00',
    amountWordsLine1: 'Three Million, Three Hundred And Sixty Nine Thousand',
    amountWordsLine2: 'Two Hundred And Ten Naira Only****',
    payTo: 'RCCG MERCY SEAT OF GOD',
    description: 'INSURANCE CLAIM LP 93',
    amountWithTax: '3,369,210.00',
    whtRate: '0.00',
    whtAmount: '0.00',
    accountDebited: '5602-300'
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>

        {/* Header Section */}
        <div className={styles.header}>
          <div className={styles.left}>
            <div className={styles.headerTitle}>CHEQUE PAYMENT</div>
            <div className={styles.formGroup}>
              <label>Payment Type</label>
              <input
                type="text"
                value={formData.paymentType}
                onChange={e => handleChange('paymentType', e.target.value)}
              />
            </div>
            <div className={styles.formGroup}>
              <label>Batch Number</label>
              <input
                type="text"
                value={formData.batchNumber}
                onChange={e => handleChange('batchNumber', e.target.value)}
              />
            </div>
          </div>

          <div className={styles.right}>
            {/* Row 1: Bank Code + Cheque Number */}
            <div className={styles.row}>
              <div className={styles.formGroup}>
                <label>Bank Code</label>
                <input
                  type="text"
                  value={formData.bankCode}
                  onChange={e => handleChange('bankCode', e.target.value)}
                />
              </div>
              <div className={styles.formGroup}>
                <label>Cheque Number</label>
                <input
                  type="text"
                  value={formData.chequeNumber}
                  onChange={e => handleChange('chequeNumber', e.target.value)}
                />
              </div>
            </div>

            {/* Row 2: Cheque Security No + Voucher # */}
            <div className={styles.row}>
              <div className={styles.formGroup}>
                <label>Cheque Security No</label>
                <input
                  type="text"
                  value={formData.chequeSecurityNo}
                  onChange={e => handleChange('chequeSecurityNo', e.target.value)}
                />
              </div>
              <div className={styles.formGroup}>
                <label>Voucher #</label>
                <input
                  type="text"
                  value={formData.voucher}
                  onChange={e => handleChange('voucher', e.target.value)}
                />
              </div>
            </div>


          </div>

        </div>

        {/* Bank Section */}
        <div className={styles.bankSection}>
          <div className={styles.bankName}>ECOBANK NIGERIA LIMITED</div>
          <div className={styles.bankAddress}>
            KM 46, LAGOS/IBADAN EXPRESS-WAY, REDEMPTION CAMP.
          </div>

          <div className={styles.payRow}>
            <span>Pay </span>
            <input
              type="text"
              value={formData.payTo}
              onChange={e => handleChange('payTo', e.target.value)}
            />
          </div>

          <div className={styles.amountSection}>
            <div className={styles.amountWords}>
              <div className={styles.sumLine}>
                <span>The sum of </span>
                <input
                  type="text"
                  value={formData.amountWordsLine1}
                  onChange={e => handleChange('amountWordsLine1', e.target.value)}
                />
              </div>
              <input
                type="text"
                value={formData.amountWordsLine2}
                onChange={e => handleChange('amountWordsLine2', e.target.value)}
              />
              <div className={styles.blankLine}></div>
            </div>

            <div className={styles.dateGroup}>
              <label>Date</label>
              <input
                type="text"
                value={formData.date}
                onChange={e => handleChange('date', e.target.value)}
              />
              <button><Calendar size={13} /></button>
            </div>
          </div>

          <div className={styles.amountRow}>
            <label>NGN</label>
            <input
              type="text"
              value={formData.amount}
              onChange={e => handleChange('amount', e.target.value)}
            />
          </div>
        </div>

        {/* Table Section */}
        <div className={styles.tableSection}>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Description of Payment</th>
                <th>Amount WHTTx</th>
                <th>WHT Rate</th>
                <th>WHT Amount</th>
                <th>Account Debited</th>
              </tr>
            </thead>
            <tbody>
              <tr className={styles.highlightRow}>
                <td>1</td>
                <td>
                  <input
                    type="text"
                    value={formData.description}
                    onChange={e => handleChange('description', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formData.amountWithTax}
                    onChange={e => handleChange('amountWithTax', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formData.whtRate}
                    onChange={e => handleChange('whtRate', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formData.whtAmount}
                    onChange={e => handleChange('whtAmount', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={formData.accountDebited}
                    onChange={e => handleChange('accountDebited', e.target.value)}
                  />
                </td>
              </tr>
              {[...Array(8)].map((_, i) => (
                <tr key={i}>
                  <td></td><td></td><td></td><td></td><td></td><td></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <button><ChevronFirst size={14} /></button>
          <button><ChevronLeft size={14} /></button>
          <button><ChevronRight size={14} /></button>
          <button><ChevronLast size={14} /></button>
          <button><FileText size={14} /></button>
          <button><Printer size={14} /></button>
          <button><Save size={14} /></button>
          <button className={styles.transferBtn}>Transfer Voucher</button>
          <button><Share size={14} /></button>
          <button><Grid3x3 size={14} /></button>
          <button className={styles.orange}><Printer size={14} /></button>
        </div>
      </div>
    </div>
  );
}
